module.exports = __webpack_public_path__ + "img/智驹APP.aff88e6f.png";